export function errorToString(error: unknown) {
  if (error instanceof Error && typeof error.message === 'string') {
    return error.message;
  }
  return String(error);
}
